<template>
	<div class="tw-flex-1 pb-8">
		<b-container
			fluid
			class="tw-text-black tw-mt-20"
		>
			<div class="tw-flex">
				<!-- Form -->
				<div class="tw-w-96 tw-flex-none tw-text-justify">
					<h2 class="tw-text-3xl tw-font-bold tw-font-ma tw-text-black">
						<slot name="form-title"></slot>
					</h2>
					<slot name="form"></slot>
				</div>
				<!-- Divider -->
				<div class="tw-flex-none tw-w-1 tw-bg-white tw-bg-opacity-60 tw-rounded-full tw-mx-10 tw-my-16"></div>
				<!-- Table -->
				<div class="tw-flex-1 tw-text-justify tw-overflow-hidden">
					<h2 class="tw-text-3xl tw-font-bold tw-font-ma tw-text-black ">
						<slot name="table-title"></slot>
					</h2>
					<slot name="table"></slot>
				</div>
			</div>
		</b-container>
	</div>
</template>
<script>
export default {
	name: 'FormTableWrapper'
};
</script>

